export default {
    images: [],
    modal: {
        show: true
    }
};



// WEBPACK FOOTER //
// ./src/modules/load_images/state.js